import React, {useState} from "react";
import axios from "axios";
import {header} from "../../Components/Url/ApiUrl";
import swal from "sweetalert";
import {Logout} from "../../Components/Actions/Actions";
import ShowFile from "../../Components/ShowFile/ShowFile";
import {useTranslation} from "react-i18next";

const FileCard = ({ region, type, token, id, handleFetch}) => {
    const {t} = useTranslation();
    const [pdfUrl, setPdfUrl] = useState(null);
    const [showFile, setShowFile] = useState(false);
    const deleteService = async (e, id, regName, type) => {
        e.preventDefault();
        if (window.confirm(t('delete_file_from_region',{regName: regName, type:type}))) {
            await axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/company/company-services/region/${id}`,
                {
                    headers:header,
                }
            ).then(res=>{
                if(res.data?.success === true){
                    swal(t('success'), res.data?.message, 'success')
                }
                if(res.data?.success === false){
                    swal(t('error'), res.data?.message, 'error')
                }
                handleFetch()
            })
                .catch(err=>{
                    if (err.response?.status === 401) {
                        Logout();
                        return;
                    }

                })
        }
    }

    const handleViewFile = async (filename) => {
        try {
            const response = await fetch(process.env.REACT_APP_API_ENDPOINT+'/files/ijara/'+filename, {
                method: "GET",
                headers: header
            });

            if (!response.ok) {
                alert(`${t('translation:cannot_upload_file')}. ${t('translation:token_expired')}`);
                window.location.reload();
                return;
            }

            const blob = await response.blob();
            if (blob.type !== "application/pdf") {
                alert(t('translation:pdf_only'));
                return;
            }
            const fileURL = URL.createObjectURL(blob);
            setPdfUrl(fileURL);
            setShowFile(true);
            // window.open(fileURL, "_blank");
        } catch (error) {
            alert(`${t('error')}: ` + error.message);
        }
    };
    return (
        <div className="card me-2">
            <i className="bi bi-filetype-pdf icon-3rem d-block m-auto"></i>
            <div className="card-body py-0 px-1 text-center d-flex flex-column">
                <small>{region}</small>
                <small style={{maxWidth:"140px", height:"35px"}} className="d-flex align-items-center">{type}</small>
                <div className="d-flex justify-content-around">
                    {token ? (
                        <button className="btn btn-link p-0"
                                onClick={() => handleViewFile(token)}>
                            <i className="bi bi-file-pdf icon-1-5rem"></i>
                        </button>
                    ) : (
                        t('translation:file_not_uploaded')
                    )}
                    <button className="btn btn-transparent  p-0"
                            style={{width: "32px", height: "32px"}}
                            onClick={(e) => {
                                deleteService(e, id, region, type)
                            }}
                    >
                        <i className="bi bi-trash icon-1-5rem text-danger"></i>
                    </button>
                </div>
            </div>
            {showFile && (
                <ShowFile
                    pdfUrl={pdfUrl}
                    setShowFile={setShowFile}
                />
            )}
        </div>
    );
};

export default FileCard;
